import React from 'react'
import { Columns, Column } from 'react-flex-columns'
import { calculateCartTotals } from './utils'
import { SimpleForm, Field } from 'shared/ui/SimpleForm'
import Icon from 'shared/ui/Icon'
import FocusedHeader from './FocusedHeader'

export default function RegistrationForm({
  send,
  context: { ticketsToPurchase, workshopData, attendees },
}) {
  const cartTotals = calculateCartTotals(workshopData, ticketsToPurchase)
  return (
    <div className="spacing">
      <FocusedHeader>Register Attendees</FocusedHeader>
      <p>
        Please register the people who will be attending, we need to send them the material and
        other information about the event.
      </p>

      <SimpleForm
        onSubmit={values => {
          send({
            type: 'SUBMIT',
            payload: values.attendees,
          })
        }}>
        {Array.from({ length: cartTotals.quantity }).map((_, index) => (
          <Columns gutters key={index}>
            <Column flex>
              <Field
                label="Name"
                name={`attendees[${index}][name]`}
                defaultValue={attendees ? attendees[index].name : ''}
                placeholder="First and Last Name"
                required
              />
            </Column>
            <Column flex>
              <Field
                label="Email"
                type="email"
                defaultValue={attendees ? attendees[index].email : ''}
                name={`attendees[${index}][email]`}
                placeholder="user@example.com"
                required
              />
            </Column>
          </Columns>
        ))}

        <Columns as="footer" split middle>
          <Column>
            <button
              type="button"
              className="icon-text"
              onClick={() => {
                send({
                  type: 'BACK_TO_TICKETS',
                })
              }}>
              <Icon name="arrow-left" />
              <span>Previous: Select Tickets</span>
            </button>
          </Column>
          <Column>
            <button type="submit" className="button icon-text">
              <span>Next: Review</span>
              <Icon name="arrow-right" size={2} />
            </button>
          </Column>
        </Columns>
        <footer></footer>
      </SimpleForm>
    </div>
  )
}
